import React from "react";
import Modal from "react-modal";
import { pickInvoiceId } from "../common/payoutInvoiceUtils";
import "./InvoiceDownloadModal.css";

function Divider() {
  return (
    <div className="invoice-download-modal__divider">
      <span className="invoice-download-modal__divider-line" />
      <span className="invoice-download-modal__divider-text">OR</span>
      <span className="invoice-download-modal__divider-line" />
    </div>
  );
}

function ModalButton({ label, onClick, variant = "primary", disabled = false }) {
  return (
    <button
      type="button"
      className={
        variant === "primary"
          ? "invoice-download-modal__primary-btn"
          : "invoice-download-modal__secondary-btn"
      }
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

function InvoiceDownloadModal({
  isOpen,
  onClose,
  isDownloading = false,
  existingInvoiceNumber = "",
  autoGeneratedInvoiceId = "",
  customInvoiceId = "",
  onCustomInvoiceIdChange,
  onDownloadWithExisting,
  onDownloadWithAutoGenerated,
  onDownloadWithCustom,
}) {
  const hasExistingInvoiceNumber = Boolean(existingInvoiceNumber);
  const customId = pickInvoiceId(customInvoiceId);
  const hasCustomInvoiceId = Boolean(customId);
  const canUpdateInvoiceNumber =
    hasCustomInvoiceId &&
    (!hasExistingInvoiceNumber || customId !== existingInvoiceNumber);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="invoice-download-modal"
      overlayClassName="invoice-download-modal__overlay"
      ariaHideApp={false}
    >
      <div className="invoice-download-modal__header">
        <div>
          <h2 className="invoice-download-modal__title">Download Invoice</h2>
          <p className="invoice-download-modal__subtitle">
            {hasExistingInvoiceNumber
              ? "Use the saved invoice number or update it before downloading."
              : "Choose an auto-generated number or enter your own."}
          </p>
        </div>
        <button
          type="button"
          className="invoice-download-modal__close"
          onClick={onClose}
          disabled={isDownloading}
          aria-label="Close"
        >
          ×
        </button>
      </div>

      <div className="invoice-download-modal__body">
        {hasExistingInvoiceNumber ? (
          <>
            <div className="invoice-download-modal__option-card">
              <div className="invoice-download-modal__eyebrow">Invoice number</div>
              <div className="invoice-download-modal__number-badge">
                <span className="invoice-download-modal__number-value">
                  {existingInvoiceNumber}
                </span>
              </div>
              <ModalButton
                label="Download Invoice"
                onClick={onDownloadWithExisting}
                disabled={isDownloading}
              />
            </div>

            <Divider />

            <div className="invoice-download-modal__option-card">
              <div className="invoice-download-modal__section-title">
                Update invoice number
              </div>
              <p className="invoice-download-modal__helper-text">
                Enter a new number only if you need to change the one above.
              </p>
              <input
                type="text"
                value={customInvoiceId}
                onChange={(event) => onCustomInvoiceIdChange(event.target.value)}
                placeholder="Enter new invoice number"
                className="invoice-download-modal__input"
                disabled={isDownloading}
              />
              <ModalButton
                label="Update & Download"
                onClick={onDownloadWithCustom}
                variant="secondary"
                disabled={!canUpdateInvoiceNumber || isDownloading}
              />
            </div>
          </>
        ) : (
          <>
            <div className="invoice-download-modal__option-card">
              <div className="invoice-download-modal__eyebrow">Auto-generated</div>
              <div className="invoice-download-modal__number-badge">
                <span className="invoice-download-modal__number-value-muted">
                  {autoGeneratedInvoiceId ||
                    "Generated automatically when you download"}
                </span>
              </div>
              <ModalButton
                label="Auto Generate Invoice ID"
                onClick={onDownloadWithAutoGenerated}
                disabled={isDownloading}
              />
            </div>

            <Divider />

            <div className="invoice-download-modal__option-card">
              <div className="invoice-download-modal__section-title">
                Custom invoice number
              </div>
              <p className="invoice-download-modal__helper-text">
                Prefer your own numbering? Enter it below.
              </p>
              <input
                type="text"
                value={customInvoiceId}
                onChange={(event) => onCustomInvoiceIdChange(event.target.value)}
                placeholder="Enter invoice number"
                className="invoice-download-modal__input"
                disabled={isDownloading}
              />
              <ModalButton
                label="Download with Custom Number"
                onClick={onDownloadWithCustom}
                disabled={!hasCustomInvoiceId || isDownloading}
              />
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

export default InvoiceDownloadModal;
